import React, { useRef, useState } from "react";
import styles from "./EstimateSettings.module.scss";
import classNames from "classnames/bind";
import EstimateLayout, { type EstimateLayoutRef } from "./estimate-layout/EstimateLayout";
import EstimateTemplate from "./estimate-template/EstimateTemplate";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import { PlusIcon } from "lucide-react";

const cx = classNames.bind(styles);

const EstimateSettings = () => {
    const [estimateSettingTab, setEstimateSettingTab] = useState<'estimate-template' | 'estimate-layout'>('estimate-template');
    const [isAddEstimateLayout, setIsAddEstimateLayout] = useState(false);
    const [isAddEstimateTemplate, setIsAddEstimateTemplate] = useState(false);
    const [showModalCreateEstimateLayout, setShowModalCreateEstimateLayout] = useState(false);
    const [isViewingCreatedLayoutPdf, setIsViewingCreatedLayoutPdf] = useState(false);
    const estimateLayoutRef = useRef<EstimateLayoutRef>(null);

    const handleEstimateSettingTabChange = (tab: 'estimate-template' | 'estimate-layout') => {
        setEstimateSettingTab(tab);
    };

    const handleContinue = () => {
        estimateLayoutRef.current?.handleContinue?.();
    };

    const renderEstimateSettingContent = () => {
        switch (estimateSettingTab) {
            case 'estimate-layout':
                return (
                    <EstimateLayout
                        ref={estimateLayoutRef}
                        isAddEstimateLayout={isAddEstimateLayout}
                        setIsAddEstimateLayout={setIsAddEstimateLayout}
                        showModalCreateEstimateLayout={showModalCreateEstimateLayout}
                        setShowModalCreateEstimateLayout={setShowModalCreateEstimateLayout}
                        onLayoutCreatedView={setIsViewingCreatedLayoutPdf}
                    />
                );
            case 'estimate-template':
                return <EstimateTemplate
                    isAddEstimateTemplate={isAddEstimateTemplate}
                    setIsAddEstimateTemplate={setIsAddEstimateTemplate}
                />;
        }
    };

    return (
        <div className={cx('estimate-settings-container')}>
            <div className={cx('estimate-settings-header')}>
                <div className={cx('left-header')}>
                    <button onClick={() => handleEstimateSettingTabChange('estimate-layout')} className={cx('estimate-setting-tab-button', estimateSettingTab === 'estimate-layout' && 'active')}>
                        Estimate Layout
                    </button>
                    <button onClick={() => handleEstimateSettingTabChange('estimate-template')} className={cx('estimate-setting-tab-button', estimateSettingTab === 'estimate-template' && 'active')}>
                        Estimate Template
                    </button>
                </div>


                <div className={cx('right-header')}>
                    {estimateSettingTab === 'estimate-layout' && isAddEstimateLayout && !isViewingCreatedLayoutPdf && (
                        <PrimaryButton
                            title='Continue'
                            onClick={handleContinue}
                            className={cx('continue-button')}
                        />
                    )}
                    {estimateSettingTab === 'estimate-layout' && !isAddEstimateLayout && (
                        <PrimaryButton
                            title='Estimate Layout'
                            icon={<PlusIcon className={cx('add-estimate-layout-icon')} />}
                            onClick={() => setShowModalCreateEstimateLayout(true)}
                            className={cx('add-estimate-layout-button')}
                        />
                    )}

                </div>


            </div>

            <div className={cx('estimate-settings-content')}>
                {renderEstimateSettingContent()}
            </div>
        </div>
    );
};

export default EstimateSettings;